import template from './list-expander.html';
import './list-expander.scss';

const DIRECTIVE_NAME = ListExpander.DIRECTIVE_NAME = 'ktListExpander';
export default function ListExpander() {
    return {
        restrict: 'A',
        controller: ListExpanderController,
        controllerAs: '$ctrl',
        template,
        bindToController: true,
        transclude: true,
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            list: `=${DIRECTIVE_NAME}List`,
            type: `@${DIRECTIVE_NAME}Type`,
        },
        link,
    };

    function link($scope, $elem, $attrs, listExpanderCtrl) {
        listExpanderCtrl.$onInit();
    }
}


export function ListExpanderController() {
    const vm = this;
    const COLLAPSED_ITEMS_COUNT = 5;
    const COLLAPSED_CUSTOM_ITEMS_COUNT = 2;
    const LIST_TYPE_AIRPORTS = 'airports';
    let collapsedItermsCount;
    Object.assign(vm, {
        $onInit,
        toggleItems,
        selectAll,
        isSelectAllVisible,
        isExpanderVisible,
        selectOne,
    });

    function $onInit() {
        vm.list = vm.list || [];
        vm.model = vm.model || [];
        vm.isCustomType = vm.type && vm.type === LIST_TYPE_AIRPORTS;
        collapsedItermsCount = vm.isCustomType ? COLLAPSED_CUSTOM_ITEMS_COUNT : COLLAPSED_ITEMS_COUNT;
        vm.visibleItemsCount = collapsedItermsCount;
        vm.isCollapsed = vm.visibleItemsCount === collapsedItermsCount;
        if (vm.isCustomType) {
            vm.customTypeList = getCustomTypeValuesList();
        }
    }

    function selectOne(Key) {
        const list = vm.isCustomType ? vm.customTypeList : vm.list;
        vm.model = [list.find((item) => item.Key === Key).Key];
    }

    function selectAll() {
        const list = vm.isCustomType ? vm.customTypeList : vm.list;
        vm.model = list.map(({Key}) => Key);
    }

    function toggleItems() {
        const list = vm.isCustomType ? vm.customTypeList : vm.list;
        vm.visibleItemsCount = vm.visibleItemsCount === collapsedItermsCount
            ? vm.visibleItemsCount = list.length
            : vm.visibleItemsCount = collapsedItermsCount;
        vm.isCollapsed = vm.visibleItemsCount === collapsedItermsCount;
    }

    function isSelectAllVisible() {
        const list = vm.isCustomType ? vm.customTypeList : vm.list;
        return list.length > 1
            && vm.model.length !== list.length;
    }

    function isExpanderVisible() {
        const list = vm.isCustomType ? vm.customTypeList : vm.list;
        return list.length > collapsedItermsCount;
    }

    function getCustomTypeValuesList() {
        return vm.list.reduce((allValues, values) => allValues.concat(...values.Airports.map((item) => item)), []);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/list-expander/list-expander-component.js